import { render } from "./PopoverManufactorView.vue?vue&type=template&id=87e339c8&scoped=true"
import script from "./PopoverManufactorView.vue?vue&type=script&lang=js"
export * from "./PopoverManufactorView.vue?vue&type=script&lang=js"

import "./PopoverManufactorView.vue?vue&type=style&index=0&id=87e339c8&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e339c8"]])

export default __exports__